// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./img/bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: left;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Replace with the actual image URL */
  background-size: cover; /* Makes the image cover the container */
  background-repeat: no-repeat; /* Prevents tiling */
  background-position: center; /* Centers the image */
  height: 100vh; /* Makes the container take the full viewport height */
  width: 100%; /* Ensures it takes the full width */
  /*margin: 0; /* Removes any margin */
  padding-top: 30px;
  padding-left: 50px; 
  padding-right: 50px; 
  display: flex; /* Allows centering content inside */
  flex-direction: column;
  /*justify-content: flex-start; /* Vertically centers content */
  /*align-items: flex-start; /* Horizontally centers content */
  overflow-y: scroll;
}

.AppHeader {
  background-color: transparent;
  /*display: flex; /* Ensures flexbox layout */
  /*justify-content: flex-start; /* Aligns items to the left */
  /*align-items: flex-start; /* Vertically centers content */
  /*margin: 0px; /* Adds some spacing */
   /* Ensures it stays at the top-left */
  /*top: 0;
  left: 0;*/
  width: 100%; /* Ensures full width */
}


.AddressContainer {
  max-width: 500px; /* Adjust as needed */
  width: 100%; /* Ensures responsiveness */
}

.Logo{
  height: 100px;
  background-color: white;
  border-radius: 5px;
  padding: 10px;
  
}

.CardPhoneNR{
  width: 330px !important;
  height: 70px ;
  background-color: #286ab8 ;
  color: white ;
  display: flex ;
  justify-content: center ;
  flex-direction: column ;
  display: none;
}

.CardBody{
  width: 730px !important;
}

.PhoneIMG{
  width: 50px;
  height: 50px;
}

.vertical-line{
  width: 1px;
  /* Adjust the width as needed */

  height: 20px;
  /* Adjust the height as needed */

  background-color: white;
  /* Change color if desired */

  margin: 0 auto;
  /* Center the line horizontally */

  transform: rotate(180deg);
  /* Rotate the line to make it vertical */

}

.AppFooter {
  background-color: transparent;
  display: flex; /* Ensures flexbox layout */
  justify-content: flex-start; /* Aligns items to the left */
  align-items: flex-start; /* Vertically centers content */
  margin: 0px; /* Adds some spacing */
   /* Ensures it stays at the top-left */
  top: 0;
  left: 0;
  width: 100%; /* Ensures full width */
}

/*.App-header {
  background-image: url('./img/AEWLogo.svg');
  min-height: 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}*/

.App-link {
  color: #61dafb;
}

.btn.btn-primary {
  background-color: #286ab8;
  border-color: #286ab8;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.btn.btn-primary:hover,
.btn.btn-primary:focus,
.btn.btn-primary:active {
  background-color: #1e4f89;
  border-color: #1e4f89;
}

.btn.btn-primary:disabled,
.btn.btn-primary[disabled] {
  background-color: #8a9bb5; 
  border-color: #8a9bb5;
  opacity: 0.65; 
  cursor: not-allowed;
}

/* Default checkbox style when unchecked */
.form-check-input {
  background-color: white !important; /* Background is white when unchecked */
  border-color: #286ab8 !important; /* Custom border color */
}

/* Change checkbox color when checked */
.form-check-input:checked {
  background-color: #286ab8 !important; /* Darker color when checked */
  border-color: #286ab8 !important; /* Darker border when checked */
}

/* Change color when focused */
.form-check-input:focus {
  border-color: #1e4f89 !important; /* Focus color */
  box-shadow: 0 0 0 0.25rem rgba(38, 106, 184, 0.5) !important; /* Focus outline */
}


.custom-width {
  max-width: 10%;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yDAAqC,EAAE,sCAAsC;EAC7E,sBAAsB,EAAE,wCAAwC;EAChE,4BAA4B,EAAE,oBAAoB;EAClD,2BAA2B,EAAE,sBAAsB;EACnD,aAAa,EAAE,sDAAsD;EACrE,WAAW,EAAE,oCAAoC;EACjD,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa,EAAE,oCAAoC;EACnD,sBAAsB;EACtB,8DAA8D;EAC9D,4DAA4D;EAC5D,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,4DAA4D;EAC5D,0DAA0D;EAC1D,qCAAqC;GACpC,qCAAqC;EACtC;WACS;EACT,WAAW,EAAE,uBAAuB;AACtC;;;AAGA;EACE,gBAAgB,EAAE,qBAAqB;EACvC,WAAW,EAAE,2BAA2B;AAC1C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;;AAEf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,cAAc;EACd,wBAAwB;EACxB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,+BAA+B;;EAE/B,YAAY;EACZ,gCAAgC;;EAEhC,uBAAuB;EACvB,4BAA4B;;EAE5B,cAAc;EACd,iCAAiC;;EAEjC,yBAAyB;EACzB,wCAAwC;;AAE1C;;AAEA;EACE,6BAA6B;EAC7B,aAAa,EAAE,2BAA2B;EAC1C,2BAA2B,EAAE,6BAA6B;EAC1D,uBAAuB,EAAE,+BAA+B;EACxD,WAAW,EAAE,sBAAsB;GAClC,qCAAqC;EACtC,MAAM;EACN,OAAO;EACP,WAAW,EAAE,uBAAuB;AACtC;;AAEA;;;;;;;EAOE;;AAEF;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,8DAA8D;AAChE;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,kCAAkC,EAAE,uCAAuC;EAC3E,gCAAgC,EAAE,wBAAwB;AAC5D;;AAEA,uCAAuC;AACvC;EACE,oCAAoC,EAAE,8BAA8B;EACpE,gCAAgC,EAAE,+BAA+B;AACnE;;AAEA,8BAA8B;AAC9B;EACE,gCAAgC,EAAE,gBAAgB;EAClD,4DAA4D,EAAE,kBAAkB;AAClF;;;AAGA;EACE,cAAc;AAChB","sourcesContent":[".App {\r\n  text-align: left;\r\n  background-image: url('./img/bg.jpg'); /* Replace with the actual image URL */\r\n  background-size: cover; /* Makes the image cover the container */\r\n  background-repeat: no-repeat; /* Prevents tiling */\r\n  background-position: center; /* Centers the image */\r\n  height: 100vh; /* Makes the container take the full viewport height */\r\n  width: 100%; /* Ensures it takes the full width */\r\n  /*margin: 0; /* Removes any margin */\r\n  padding-top: 30px;\r\n  padding-left: 50px; \r\n  padding-right: 50px; \r\n  display: flex; /* Allows centering content inside */\r\n  flex-direction: column;\r\n  /*justify-content: flex-start; /* Vertically centers content */\r\n  /*align-items: flex-start; /* Horizontally centers content */\r\n  overflow-y: scroll;\r\n}\r\n\r\n.AppHeader {\r\n  background-color: transparent;\r\n  /*display: flex; /* Ensures flexbox layout */\r\n  /*justify-content: flex-start; /* Aligns items to the left */\r\n  /*align-items: flex-start; /* Vertically centers content */\r\n  /*margin: 0px; /* Adds some spacing */\r\n   /* Ensures it stays at the top-left */\r\n  /*top: 0;\r\n  left: 0;*/\r\n  width: 100%; /* Ensures full width */\r\n}\r\n\r\n\r\n.AddressContainer {\r\n  max-width: 500px; /* Adjust as needed */\r\n  width: 100%; /* Ensures responsiveness */\r\n}\r\n\r\n.Logo{\r\n  height: 100px;\r\n  background-color: white;\r\n  border-radius: 5px;\r\n  padding: 10px;\r\n  \r\n}\r\n\r\n.CardPhoneNR{\r\n  width: 330px !important;\r\n  height: 70px ;\r\n  background-color: #286ab8 ;\r\n  color: white ;\r\n  display: flex ;\r\n  justify-content: center ;\r\n  flex-direction: column ;\r\n  display: none;\r\n}\r\n\r\n.CardBody{\r\n  width: 730px !important;\r\n}\r\n\r\n.PhoneIMG{\r\n  width: 50px;\r\n  height: 50px;\r\n}\r\n\r\n.vertical-line{\r\n  width: 1px;\r\n  /* Adjust the width as needed */\r\n\r\n  height: 20px;\r\n  /* Adjust the height as needed */\r\n\r\n  background-color: white;\r\n  /* Change color if desired */\r\n\r\n  margin: 0 auto;\r\n  /* Center the line horizontally */\r\n\r\n  transform: rotate(180deg);\r\n  /* Rotate the line to make it vertical */\r\n\r\n}\r\n\r\n.AppFooter {\r\n  background-color: transparent;\r\n  display: flex; /* Ensures flexbox layout */\r\n  justify-content: flex-start; /* Aligns items to the left */\r\n  align-items: flex-start; /* Vertically centers content */\r\n  margin: 0px; /* Adds some spacing */\r\n   /* Ensures it stays at the top-left */\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%; /* Ensures full width */\r\n}\r\n\r\n/*.App-header {\r\n  background-image: url('./img/AEWLogo.svg');\r\n  min-height: 10vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}*/\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n.btn.btn-primary {\r\n  background-color: #286ab8;\r\n  border-color: #286ab8;\r\n  transition: background-color 0.3s ease, border-color 0.3s ease;\r\n}\r\n\r\n.btn.btn-primary:hover,\r\n.btn.btn-primary:focus,\r\n.btn.btn-primary:active {\r\n  background-color: #1e4f89;\r\n  border-color: #1e4f89;\r\n}\r\n\r\n.btn.btn-primary:disabled,\r\n.btn.btn-primary[disabled] {\r\n  background-color: #8a9bb5; \r\n  border-color: #8a9bb5;\r\n  opacity: 0.65; \r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Default checkbox style when unchecked */\r\n.form-check-input {\r\n  background-color: white !important; /* Background is white when unchecked */\r\n  border-color: #286ab8 !important; /* Custom border color */\r\n}\r\n\r\n/* Change checkbox color when checked */\r\n.form-check-input:checked {\r\n  background-color: #286ab8 !important; /* Darker color when checked */\r\n  border-color: #286ab8 !important; /* Darker border when checked */\r\n}\r\n\r\n/* Change color when focused */\r\n.form-check-input:focus {\r\n  border-color: #1e4f89 !important; /* Focus color */\r\n  box-shadow: 0 0 0 0.25rem rgba(38, 106, 184, 0.5) !important; /* Focus outline */\r\n}\r\n\r\n\r\n.custom-width {\r\n  max-width: 10%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
